module.exports = __webpack_public_path__ + "static/genasi-earth-1-f0d28261082affd45141e43398859afa.jpg";